export const filterOperatorLabel = (count: number, excluded: boolean): string => {
    if (excluded) return count > 1 ? 'non è fra' : 'non è';
    return count > 1 ? 'è fra' : 'è';
};

export default filterOperatorLabel;
